import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const EmailLayoutsRoutes: Routes = [
  {
    path: "email-layouts",
    loadComponent: () =>
      import("./email-layouts/email-layouts.component").then(
        (m) => m.EmailLayoutsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./email-layouts-list/email-layouts-list.component").then(
            (m) => m.EmailLayoutsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./email-layouts-form/email-layouts-form.component").then(
            (m) => m.EmailLayoutsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./email-layouts-form/email-layouts-form.component").then(
            (m) => m.EmailLayoutsFormComponent,
          ),
      },
    ],
  },
];
